import {
  Box,
  Container,
  Divider,
  Grid,
  Link,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import VerticalAlignTopIcon from "@mui/icons-material/VerticalAlignTop";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import FavoriteIcon from "@mui/icons-material/Favorite";
import {
  FaYoutube,
  FaTwitter,
  FaFacebookF,
  FaSkype,
  FaGithub,
  FaDiscord,
  FaTelegram,
  FaTextWidth,
  FaMedium,
} from "react-icons/fa";
import XIcon from "@mui/icons-material/X";
import EmailIcon from "@mui/icons-material/Email";
import { useRecoilState } from "recoil";
import { ThemeLight } from "../../state/ThemeLight";
import { DonationModal } from "../../components/DonationModal";
import { useState } from "react";

const Footer = () => {
  const [themeLight] = useRecoilState(ThemeLight);

  const [openDonationModal, setOpenDonationModal] = useState<boolean>(false);

  return (
    <Container className="container-xxl">
      <Box className="d-flex justify-content-between align-items-baseline py-6">
        <Link
          className="link-dark"
          href="#"
          rel="nofollow noopener"
          data-bs-toggle="tooltip"
          data-bs-trigger="hover"
          data-bs-placement="top"
          aria-label="Twitter"
        >
          <VerticalAlignTopIcon fontSize="small" />
          Back to Top
        </Link>
      </Box>
      <Divider />

      <Grid container className="row justify-content-md-between py-8 py-lg-10">
        <Grid item xs={4} lg={4} className="pe-xl-16 mb-4 mb-lg-0">
          <Box className="d-flex align-items-center mb-3">
            <img
              src={
                themeLight
                  ? "/assets/img/logo.png"
                  : "/assets/img/logo_title_white.png"
              }
              width={200}
              className="me-2"
              alt="UPCX Footer"
            />
          </Box>

          <Box className="d-flex gap-2 mt-4">
            <Link
              className="footer-sns"
              href="mailto:tech-admin@upcx.org"
              rel="nofollow noopener"
              target="_blank"
              data-bs-toggle="tooltip"
              data-bs-trigger="hover"
              data-bs-placement="top"
              aria-label="Twitter"
            >
              <EmailIcon
                sx={{
                  width: 18,
                  height: 18,
                  ...(themeLight ? {} : { color: "white !important" }),
                }}
              />
            </Link>

            <Link
              className="footer-sns"
              href="https://medium.com/@UPCX-Platforms"
              rel="nofollow noopener"
              target="_blank"
              data-bs-toggle="tooltip"
              data-bs-trigger="hover"
              data-bs-placement="top"
              aria-label="Twitter"
            >
              <FaMedium
                size={18}
                style={themeLight ? {} : { color: "white !important" }}
              />
            </Link>

            <Link
              className="footer-sns"
              href="https://twitter.com/Upcxofficial"
              rel="nofollow noopener"
              target="_blank"
              data-bs-toggle="tooltip"
              data-bs-trigger="hover"
              data-bs-placement="top"
              aria-label="Twitter"
            >
              <XIcon
                sx={{
                  width: 18,
                  height: 18,
                  ...(themeLight ? {} : { color: "white !important" }),
                }}
              />
            </Link>

            <Link
              className="footer-sns"
              href="https://t.me/UPCXofficial"
              rel="nofollow noopener"
              target="_blank"
              data-bs-toggle="tooltip"
              data-bs-trigger="hover"
              data-bs-placement="top"
              aria-label="Twitter"
            >
              <FaTelegram
                size={18}
                style={themeLight ? {} : { color: "white !important" }}
              />
            </Link>
            <Link
              className="footer-sns"
              href="http://dsc.gg/upcx"
              rel="nofollow noopener"
              target="_blank"
              data-bs-toggle="tooltip"
              data-bs-trigger="hover"
              data-bs-placement="top"
              aria-label="Twitter"
            >
              <FaDiscord
                size={18}
                style={themeLight ? {} : { color: "white !important" }}
              />
            </Link>
            <Link
              className="footer-sns"
              href="https://github.com/UPCX-TEAM-B"
              rel="nofollow noopener"
              target="_blank"
              data-bs-toggle="tooltip"
              data-bs-trigger="hover"
              data-bs-placement="top"
              aria-label="Twitter"
            >
              <FaGithub
                size={18}
                style={themeLight ? {} : { color: "white !important" }}
              />
            </Link>
          </Box>
        </Grid>
        <Grid item xs={2} lg={2}>
          <Typography className="h6 mb-3">Company</Typography>

          <List
            className="list-unstyled list-sm-space fs-sm mb-0"
            disablePadding
          >
            {/* <ListItem disablePadding>
              <Link href="#" className="link-dark">
                About Us
              </Link>
            </ListItem> */}
            <ListItem disablePadding>
              <Link href="/contactus" className="link-dark">
                Contact Us
              </Link>
            </ListItem>

            <ListItem disablePadding>
              <Link href="/privacy_policy" className="link-dark">
                Privacy Policy
              </Link>
            </ListItem>

            <ListItem disablePadding>
              <Link href="/legal_disclaimer" className="link-dark">
                Legal Disclaimer
              </Link>
            </ListItem>

            <ListItem disablePadding>
              <Link href="/cookie_policy" className="link-dark">
                Cookie Policy
              </Link>
            </ListItem>
            {/* <ListItem disablePadding>
              <Link href="#" className="link-dark">
                Bug Bounty
              </Link>
            </ListItem> */}
          </List>
        </Grid>
        <Grid item xs={2} lg={2}>
          <Typography className="h6 mb-3">Community</Typography>

          <List
            className="list-unstyled list-sm-space fs-sm mb-0"
            disablePadding
          >
            <ListItem disablePadding>
              <Link
                href="https://explorer.upcx.org:5000/api"
                className="link-dark"
                target="_blank"
                rel="noreferrer"
              >
                API Documentation
              </Link>
            </ListItem>
            <ListItem disablePadding>
              <Link href="/knowledge" className="link-dark">
                Knowledge Base
              </Link>
            </ListItem>
            <ListItem disablePadding>
              <Link href="/network_status" className="link-dark">
                Network Status
              </Link>
            </ListItem>
            <ListItem disablePadding>
              <Link href="/newsletter" className="link-dark">
                Newsletters
              </Link>
            </ListItem>
          </List>
        </Grid>
        <Grid item xs={3} lg={3}>
          <Typography className="h6 mb-3">Products & Services</Typography>

          <List
            className="list-unstyled list-sm-space fs-sm mb-0"
            disablePadding
          >
            <ListItem disablePadding>
              <Link href="/apiplans" className="link-dark">
                API Plans
              </Link>
            </ListItem>
            {/* <ListItem disablePadding>
              <Link href="#" className="link-dark">
                Priority Support
              </Link>
            </ListItem> */}
            {/* <ListItem disablePadding>
              <Link href="#" className="link-dark">
                Blockscan
                <OpenInNewIcon fontSize="small" className="ms-1" />
              </Link>
            </ListItem> */}
          </List>
        </Grid>
      </Grid>

      <Box className="border-top py-4">
        <Grid
          container
          className="justify-content-between align-items-center fs-sm"
        >
          <Grid item md>
            <Typography className="mb-0 fs-sm">
              UPCX Explorer © 2024 (C1)
            </Typography>
          </Grid>
          <Grid
            item
            md
            className="text-md-end cursor-pointer"
            onClick={() => {
              setOpenDonationModal(true);
            }}
          >
            <Typography className="mb-0 fs-sm">
              Donations{" "}
              <FavoriteIcon className="text-danger" fontSize="small" />
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <DonationModal
        open={openDonationModal}
        handleOpen={setOpenDonationModal}
      />
    </Container>
  );
};

export default Footer;
